import React from 'react';
import { Outlet } from 'react-router-dom';
import { OrganizationFacilityProvider } from '../context';

const OrganizationFacilityLayout = () => (
  <OrganizationFacilityProvider>
    <Outlet />
  </OrganizationFacilityProvider>
);

export default OrganizationFacilityLayout;
